import styles from './DadosItensPedido.module.scss';
import { useEffect, useState } from "react";
import { IitemPedido } from "../../../interfaces/itemPedido";
import { IPedido } from "../../../interfaces/pedido.interface";
import { formatarNumeroBR } from '../../../utils/formatacao';

export default function DadosItensPedido({ itens, pedido }: { itens: IitemPedido[]; pedido: IPedido }) {
    const [valorTotal, setValorTotal] = useState<number>(0);
    const [totalABC, setTotalABC] = useState<number>(0);

    // Função para calcular o valor total dos itens
    const somaItens = () => {
        const total = itens.reduce((soma, item) => soma + (item.valorUnidade * item.quantidade), 0);
        setValorTotal(total);
        totalAB(total);
    };

    const totalAB = (valorTotal: number) => {
        const valorFrete = Number(pedido.valorFrete);
        const descontos = Number(pedido.descontos);

        setTotalABC(
            pedido.fretePagoPor === 'Contratante'
            ? (valorTotal + valorFrete) - descontos
            : valorTotal - (valorFrete + descontos)
        )

        return 
    };

    useEffect(() => {
        somaItens();
    }, [itens]);

    return (
        <div className={styles.container}>
            <table>
                <thead>
                    <tr>
                        <th>ITEM</th>
                        <th>DESCRIÇÂO DO PRODUTO</th>
                        <th>UND.</th>
                        <th>QTDE.</th>
                        <th>UNIT R$</th>
                        <th>SUB-TOTAL R$</th>
                    </tr>
                </thead>

                <tbody>
                    {itens.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.descricao}</td>
                            <td>{item.unidade}</td>
                            <td>{item.quantidade}</td>
                            <td>{Number(item.valorUnidade).toFixed(2)}</td>
                            <td>{(item.valorUnidade * item.quantidade).toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className={styles.containerTotal}>
                <div className={styles.obs}>
                    <h4 className={styles.title}>OBSERVAÇÃO</h4>

                    <div>
                        <h4>PERÍODO DE ENTREGA: </h4>
                        <p>{pedido.dataEntrega ? new Date(pedido.dataEntrega).toLocaleDateString() : ''}</p>
                    </div>

                    <div>
                        <h4>O FRETE SERÁ PAGO PELO: </h4>
                        <p>{pedido.fretePagoPor}</p>
                    </div>
                </div>

                <div className={styles.subTotal}>
                    <div>
                        <h4>SUBTOTAL (A)</h4>
                        <p>R$ {formatarNumeroBR(Number(valorTotal))}</p>
                    </div>

                    <div>
                        <h4>FRETE (B)</h4>
                        <p>R$ {pedido.valorFrete ? formatarNumeroBR(Number(pedido.valorFrete)) : '0.00'}</p>
                    </div>

                    <div>
                        <h4>DESCONTOS (C)</h4>
                        <p>R$ {pedido.descontos ? formatarNumeroBR(Number(pedido.descontos)) : '0.00'}</p>
                    </div>

                    <div>
                        <h4>TOTAL (A+B-C)</h4>
                        <p>R$ {formatarNumeroBR(totalABC)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
